export const extractDataConstants = {
  SHOW: 'EXTRACTION_DATA_SHOW',
  UPDATE: 'EXTRACTION_DATA_UPDATE',
  CLEAR: 'CLEAR_EXTRACT_DATA',
}
